import React from "react";
import arrowR from "./../assets/arrowR.png";
import arrowL from "./../assets/arrowL.png";
import { workModes } from "./../teams";

const Step3 = ({
  setCurrentStep,
  setCurrentManagerIndex,
  selectedWorkMode,
  setSelectedWorkMode,
  t,
  lang
}) => {
  // Funzione per selezionare/deselezionare più modalità di lavoro
  const toggleWorkModeSelection = (modeId) => {
    setSelectedWorkMode((prevModes) => {
      if (prevModes.includes(modeId)) {
        return prevModes.filter((id) => id !== modeId);
      } else {
        return [...prevModes, modeId];
      }
    });
  };


  return (
    <div>
      <h1 className="h1Config">{t.titleStep3}</h1>
      <p className="subTitle">{t.subtitleStep3}</p>

      {/* Sezione delle modalità di lavoro */}
      <div className="work-modes-grid">
        {workModes.map((mode) => (
          <div
            key={mode.id}
            className={`work-mode-card ${selectedWorkMode.includes(mode.id) ? "selected" : ""}`}
            onClick={() => toggleWorkModeSelection(mode.id)}
          >
            <div className="mode-header"></div>
            <div className="modeCerchio"><img src={mode.icon} alt={mode.title} /></div>
            <h3 className="modeTitle">{mode.title[lang]}</h3>
            <p className="modeDescription">{mode.description[lang]}</p>
          </div>
        ))}
      </div>

      {/* Sezione dei pulsanti di navigazione */}
      <div className="navigation-buttons button-container">
        <button
          onClick={() => {
            setCurrentStep(2);
            setCurrentManagerIndex(0);
          }}
        >
          <img src={arrowL} alt="Freccia sinistra" /> {t.indietro}
        </button>

          <button onClick={() => setCurrentStep(4)} disabled={selectedWorkMode.length === 0}>
          {t.avanti} <img src={arrowR} alt="Freccia destra" />
        </button>
      </div>
    </div>
  );
};

export default Step3;
